

































































import { Vue, Component, Ref } from 'vue-property-decorator'
import { parse } from 'papaparse'
import moment from 'moment'
import ListView from '@/components/ListView.vue'
import DateSelect from '@/components/DateSelect.vue'
import ShopAutocomplete from '@/components/ShopAutocomplete.vue'
import CSVExportBtn from '@/components/CSVExport.vue'
import { Shop } from '@/types/shop'
import { formatDateForDisplay } from '@/utils'

const parseCSV = (file: File) => {
  return new Promise((resolve, reject) => {
    parse(file, {
      error: err => {
        reject(err)
      },
      complete: results => {
        return resolve(results.data)
      },
    })
  })
}

const transformCSV = (data: string[][], shops: Shop[]) => {
  const header = data[0]
  if (!header) return []
  const shopCodeIdx = header.findIndex(x => String(x).match('コード'))
  const dateIdx = header.findIndex(x => String(x).match('日'))
  const memoIdx = header.findIndex(x => String(x).match('メモ'))
  const code2id: Map<string, Shop> = new Map()
  shops.forEach(shop => {
    code2id.set(shop.code, shop)
  })
  data = data.slice(1)
  return data.map(row => {
    const shop = code2id.get(row[shopCodeIdx])
    const date = moment(row[dateIdx])
    return {
      isValid: Boolean(shop) && date.isValid(),
      shop: shop?.id,
      shopCode: row[shopCodeIdx],
      shopName: shop?.name,
      date: date.isValid() ? date.format('YYYY-MM-DD') : '',
      memo: row[memoIdx] || '',
    }
  })
}

@Component({
  components: { ListView, DateSelect, ShopAutocomplete, CSVExportBtn },
})
export default class HolidayView extends Vue {
  @Ref() readonly listView!: ListView

  filterDefinition = {
    ordering: { type: String, default: '-created' },
    shop: { type: String, default: null },
    dateFrom: { type: String, default: null },
    dateTo: { type: String, default: null },
  }
  filter: null | Record<string, any> = null
  selected: number[] = []

  get headers() {
    return [
      { text: this.$t('purchasedTicket.text.ticketName'), value: 'name' },
      { text: this.$t('purchasedTicket.text.group'), value: 'groupName' },
      { text: this.$t('purchasedTicket.text.active'), value: 'isActive' },

      { text: this.$t('purchasedTicket.text.customerCode'), value: 'customerCode', width: 100 },
      { text: this.$t('purchasedTicket.text.customerName'), value: 'customerName', width: 100 },

      { text: this.$t('purchasedTicket.text.creator'), value: 'createdUsername' },
      { text: this.$t('purchasedTicket.text.quantity'), value: 'quantity' },
      { text: this.$t('purchasedTicket.text.usedQuantity'), value: 'usedQuantity' },
      { text: this.$t('purchasedTicket.text.expiryDate'), value: 'expiryAt' },
      { text: this.$t('purchasedTicket.text.updatedDate'), value: 'updated' },
      { text: this.$t('purchasedTicket.text.createdDate'), value: 'created' },
      { text: this.$t('purchasedTicket.text.pubsubId'), value: 'pubsubMessageid' },
      { text: this.$t('purchasedTicket.text.price'), value: 'price' },
    ]
  }
  shops: Shop[] = []
  bulkData: {
    isValid: boolean
    shopCode: any
    shopName: any
    shop: any
    date: string
    memo: string
  }[] = []
  dialog = false
  get csvHeaders() {
    const t = this.$t.bind(this)
    return [
      { key: 'name', label: t('purchasedTicket.text.ticketName') },
      { key: 'groupName', label: t('purchasedTicket.text.group') },
      { key: 'group', label: t('purchasedTicket.csv.ticketId') },
      { key: 'isActive', label: t('purchasedTicket.text.active') },
      { key: 'customerCode', label: t('purchasedTicket.text.customerCode') },
      { key: 'customerName', label: t('purchasedTicket.text.customerName') },
      { key: 'ecProductId', label: t('purchasedTicket.csv.ecProductId') },
      { key: 'createdUsername', label: t('purchasedTicket.text.creator') },
      { key: 'quantity', label: t('purchasedTicket.text.quantity') },
      { key: 'usedQuantity', label: t('purchasedTicket.text.usedQuantity') },
      {
        key: (item: any) =>
          formatDateForDisplay(item.expiryAt, this.$i18n.locale),
        label: t('purchasedTicket.csv.expiryDate'),
      },
      {
        key: (item: any) => extractTime(item.expiryAt),
        label: t('purchasedTicket.csv.expiryTime'),
      },
      {
        key: (item: any) =>
          formatDateForDisplay(item.created, this.$i18n.locale),
        label: t('purchasedTicket.csv.createdDate'),
      },
      {
        key: (item: any) => extractTime(item.created),
        label: t('purchasedTicket.csv.createdTime'),
      },
      { key: 'pubsubMessageid', label: t('purchasedTicket.text.pubsubId') },
      { key: 'price', label: t('purchasedTicket.text.price') },
      { key: 'id', label: t('purchasedTicket.csv.purchaseId') },
    ]
  }
  created() {
    this.fetchShop()
  }
  updateQuery() {
    if (this.filter !== null) this.listView.updateQuery(this.filter)
    this.selected = []
  }
  async fetchShop(nextUrl?: string) {
    const { results, next } = await (nextUrl
      ? this.$api.http.get(nextUrl)
      : this.$api.shops().list())
    this.shops = this.shops.concat(results)
    if (next) this.fetchShop(next)
  }

  async onFileChanged(file: null | File) {
    console.log('onFileChanged', file)
    if (file) {
      const csvData = (await parseCSV(file)) as any[][]
      this.bulkData = transformCSV(csvData, this.shops)
    }
  }
}
const extractTime = (value: any) => (value ? moment(value).format('HH:mm') : '')
